<template>
    <NuxtLayout>
        <ContentInfo />
        <div class="container">
            <Advantages />
            <CargoTransportation />
            <TransportationTable />
            <Geography />
            <Branches />
            <Steps />
            <TypesOfCargo />
        </div>
        <ContactForm />
    </NuxtLayout>
</template>

<script setup>
import ContentInfo from '~/components/home/ContentInfo.vue';
import Advantages from '~/components/home/Advantages.vue';
import CargoTransportation from '~/components/home/CargoTransportation.vue';
import TransportationTable from '~/components/home/TransportationTable.vue';
import Geography from '~/components/home/Geography.vue';
import Branches from '~/components/home/Branches.vue';
import Steps from '~/components/home/Steps.vue';
import TypesOfCargo from '~/components/home/TypesOfCargo.vue';
import ContactForm from '~/components/home/ContactForm.vue';

useHead({
    script: [
        {
            type: 'application/ld+json',
            children: JSON.stringify({
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Organization",
                        "@id": "https://pecom.by/#organization",
                        "name": "ПЭК Беларусь",
                        "legalName": "Общество с ограниченной ответственностью «ПЭК Бел»",
                        "alternateName": [
                            "ООО «ПЭК Бел»",
                            "ПЭК Бел",
                            "PEC Belarus",
                            "PEC Bel"
                        ],
                        "url": "https://pecom.by/",
                        "logo": "https://pecom.by/icon/loco-pec.png",
                        "image": "https://pecom.by/_nuxt/by-bg.png",
                        "description": "Транспортно-логистическая компания ПЭК Беларусь (ООО «ПЭК Бел»). Перевозки сборных (LTL) и генеральных (FTL) грузов, ответственное хранение. Ежедневные рейсы Беларусь — Россия. Международные перевозки по направлению ПЭК: SILK WAY (Армения, Казахстан, Кыргызстан, Узбекистан, Таджикистан). Зарегистрирована 28 октября 2020 года в Минске. 1 основное отделение + 5 франчайзинговых отделений в Беларуси.",
                        "telephone": "+375173361999",
                        "email": "minsk@pecom.ru",
                        "contactPoint": [
                            {
                                "@type": "ContactPoint",
                                "telephone": "+375173361999",
                                "contactType": "customer support",
                                "areaServed": {
                                    "@type": "Country",
                                    "name": "Беларусь"
                                },
                                "availableLanguage": ["ru"]
                            }
                        ],
                        "address": {
                            "@type": "PostalAddress",
                            "streetAddress": "пер. Твёрдый 1-й, 11",
                            "addressLocality": "Минск",
                            "postalCode": "220037",
                            "addressCountry": "BY"
                        },
                        "identifier": [
                            {
                                "@type": "PropertyValue",
                                "propertyID": "УНП",
                                "value": "193484328"
                            },
                            {
                                "@type": "PropertyValue",
                                "propertyID": "ОКПО",
                                "value": "504549605000"
                            }
                        ],
                        "foundingDate": "2020-10-28",
                        "areaServed": [
                            {
                                "@type": "Country",
                                "name": "Беларусь"
                            },
                            {
                                "@type": "Country",
                                "name": "Россия"
                            },
                            {
                                "@type": "Country",
                                "name": "Армения"
                            },
                            {
                                "@type": "Country",
                                "name": "Казахстан"
                            },
                            {
                                "@type": "Country",
                                "name": "Кыргызстан"
                            },
                            {
                                "@type": "Country",
                                "name": "Узбекистан"
                            },
                            {
                                "@type": "Country",
                                "name": "Таджикистан"
                            }
                        ],
                        "knowsAbout": [
                            "Перевозка сборных грузов (LTL)",
                            "Перевозка выделенным транспортом (FTL)",
                            "Ответственное хранение грузов",
                            "Международные перевозки",
                            "Логистика Беларусь — Россия (ежедневные рейсы)"
                        ],
                        "department": [
                            {
                                "@type": "LocalBusiness",
                                "@id": "https://pecom.by/#minsk-office",
                                "name": "ПЭК Минск — главное отделение",
                                "image": "https://pecom.by/_nuxt/by-bg.png",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "ул. Минская кольцевая автомобильная дорога, д. 21",
                                    "addressLocality": "Минск",
                                    "postalCode": "220138",
                                    "addressCountry": "BY"
                                },
                                "telephone": "+375173361999"
                            },
                            {
                                "@type": "LocalBusiness",
                                "name": "ПЭК Гомель (франчайзинговое отделение)",
                                "telephone": "+375298007778",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "ул. Хатаевича, дом 15а",
                                    "addressLocality": "Гомель",
                                    "postalCode": "246006",
                                    "addressCountry": "BY"
                                }
                            },
                            {
                                "@type": "LocalBusiness",
                                "name": "ПЭК Гродно (франчайзинговое отделение)",
                                "telephone": "+375336537778",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "ул. Якуба Коласа, д. 38А/3",
                                    "addressLocality": "Гродно",
                                    "postalCode": "230003",
                                    "addressCountry": "BY"
                                }
                            },
                            {
                                "@type": "LocalBusiness",
                                "name": "ПЭК Могилёв (франчайзинговое отделение)",
                                "telephone": "+375445627778",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "ул. Вокзальная, д. 9А",
                                    "addressLocality": "Могилёв",
                                    "postalCode": "212001",
                                    "addressCountry": "BY"
                                }
                            },
                            {
                                "@type": "LocalBusiness",
                                "name": "ПЭК Витебск (франчайзинговое отделение)",
                                "telephone": "+375212652225",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "Полярная улица, 2",
                                    "addressLocality": "Витебск",
                                    "postalCode": "210017",
                                    "addressCountry": "BY"
                                }
                            },
                            {
                                "@type": "LocalBusiness",
                                "name": "ПЭК Брест (франчайзинговое отделение)",
                                "telephone": "+375162355000",
                                "address": {
                                    "@type": "PostalAddress",
                                    "streetAddress": "ул. Янки Купалы, 17/1",
                                    "addressLocality": "Брест",
                                    "postalCode": "224020",
                                    "addressCountry": "BY"
                                }
                            }
                        ],
                        "potentialAction": [
                            {
                                "@type": "CommunicateAction",
                                "name": "Позвонить в ПЭК Беларусь",
                                "target": "tel:+375173361999"
                            }
                        ]
                    },
                    {
                        "@type": "WebSite",
                        "@id": "https://pecom.by/#website",
                        "url": "https://pecom.by/",
                        "name": "ПЭК Беларусь — официальный сайт",
                        "description": "Официальный сайт транспортно-логистической компании ПЭК в Республике Беларусь",
                        "publisher": {
                            "@id": "https://pecom.by/#organization"
                        },
                        "inLanguage": "ru"
                    }
                ]
            }),
        },
    ],
    meta: [
        // Open Graph
        { property: 'og:title', content: 'Перевозки Беларусь — Россия: доставка грузов и логистика | ПЭК' },
        { property: 'og:description', content: 'Грузоперевозки в Беларусь и из Беларуси в Россию от ПЭК. Доставка грузов, оформление документов, контроль сроков. Работаем с бизнесом и частными клиентами, расчет стоимости онлайн.' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://pecom.by' },
        { property: 'og:image', content: 'https://pecom.by/_nuxt/by-bg.png' },
        { property: 'og:image:alt', content: 'Перевозки Беларусь Россия' },
        { property: 'og:site_name', content: 'ПЭК' },
        { property: 'og:locale', content: 'ru_RU' },

        // Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Перевозки Беларусь — Россия: доставка грузов и логистика | ПЭК' },
        { name: 'twitter:description', content: 'Грузоперевозки в Беларусь и из Беларуси в Россию от ПЭК. Доставка грузов, оформление документов, контроль сроков. Работаем с бизнесом и частными клиентами, расчет стоимости онлайн.' },
        { name: 'twitter:image', content: 'https://pecom.by/_nuxt/by-bg.png' },
        { name: 'twitter:image:alt', content: 'Перевозки Беларусь Россия' },
    ]
})
</script>

<style scoped>
.container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0;

    @media screen and (max-width: 1300px) {
        max-width: unset;
        margin: 0;
        padding: 0 16px;
    }
}

.section-title {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    leading-trim: NONE;
    line-height: 46px;
    letter-spacing: 0%;
    margin: 0;
}

.subsection-title {
    font-weight: 500;
    font-style: Medium;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;
}

@media screen and (max-width: 1279px) {
    .section-title {
        font-size: 24px;
        line-height: 32px;
    }
}

@media screen and (max-width: 768px) {
    .section-title {
        font-size: 22px;
        line-height: 28px;
    }

    .subsection-title {
        font-size: 18px;
        line-height: 26px;
    }
}
</style>
